import { motion } from 'framer-motion';
import { ReactNode } from 'react';

type AnimatedPageProps = {
  children: ReactNode;
};

export default function AnimatedPage({ children }: AnimatedPageProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.18, ease: 'easeOut' }}
      style={{ width: '100%', minHeight: '100%', display: 'block' }}
    >
      {children}
    </motion.div>
  );
}
